const langtrans={
      dddsqz:["等待授权中","Waiting for authorization"],
      qssjj:["起始时间","Start time"],
      jjssjj:["结束时间不能早于起始时间","Finish time cannot be earlier than the start time"],
	  jjss:["结束时间","End time"],
      czx:["查询","Check"],
      zwmsss:["暂无数据","Data is temporary not available"],
      xhh:["序号","Serial no."],
      ajbhh:["案件编号","Case no."],
      ffsddd:["发生地点","Case location"],
      yhxm:["用户姓名","User name"],
      yhsjhh:["用户手机号","Mobile no."],
      zjxsxx:["证件信息","ID information"],
      xbb:["性别","Gender"],
      cxsjj:["出险时间","Time of claim"],
      yhbxxq:["用户保险详情","Policy details"],
      bxxqq:["保险详情","Policy details"],
      wm:["无","None"],
      ddqjdd:["当前进度","Current progress"],
      ddqjjd:["当前节点","Current node"],
      hfsjj:["回复时间","Time of reply"],
      cczzz:["操作","Operating Party"],
      czkkbj:["查看报价详情","Check and process"],
      qqlll:["请求了","en_translated"],
      n:["男","Male"],
      nr:["女","Female"],
      zzzhzz:["指挥中心关闭报价","en_translated"],
      bjjjyg:["报价已关闭"," quotation closed"],
      czkkbb:["查看并操作","Check and operate"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/offer.vue.trans.js